<template>
	<div :class="iconClass">
		<sym-icon v-if="loading" name="refresh" class="uploadingIcon" />
		<sym-icon v-else :name="icon" @click.prevent="onFileInput" />
		<input type="file" ref="fileInputId" @change="onInputChange" style="display: none;" :disabled="readOnly" />
		<div v-if="isError" class="errors">
			<span class="perr">{{errorMessage}}</span>
		</div>
	</div>
</template>

<script setup lang="ts">
	import {ref, computed} from 'vue';
	import {injectEnv} from "@fd/Environment";
	import SymIcon from "@fd/helpers/SymIcon.vue";
	import type {AttFile} from "@t/file/AttFile.ts";
	
	const props = defineProps({
		icon: { type: String, default: 'upload' },
		typeFilter: String,
		readOnly: Boolean,
	});
	
	const fileStore = defineModel<AttFile[]>();
	const emit = defineEmits(['uploaded']);
	const errorMessage = ref("");
	const fileInputId = ref(null);
	const loading = ref<boolean>(false);
	
	const isError = computed<boolean>(() => {
		return  errorMessage.value !== null && errorMessage.value !== undefined && errorMessage.value.length>0;
	});
	
	const iconClass = computed<string>(() => {
		return  props.readOnly?"disabled-click":"activeclick";
	});
	
	function onFileInput(): void {
		fileInputId.value.click();
	}

	async function onInputChange(e): void {
		try {
			let file = e.target.files[0];
			if (canUpload(file)) {
				loading.value=true;
				const buffer = await file.arrayBuffer();
				const content = new Uint8Array(buffer);
				console.log("adding file:"+file.name+" with size:"+ content.length);
				var uploadedFile = toAttFile(file,content);
				if (typeof fileStore.value === 'undefined' ||  fileStore.value === null) {
					fileStore.value = [uploadedFile];
				}
				else {
					fileStore.value.push(uploadedFile);
				}
				e.target.value = null;
				emit('uploaded');
				//console.log("fileStores:"+fileStore.value.length);
			}
		}
		finally {
			loading.value=false;
		}
	}
	
	function canUpload(file: File) : boolean {
		return !fileExists(file) && isValidFile(file, filterToArray(props.typeFilter));
	}
	
	function toAttFile(file: File, fileContent: Uint8Array): AttFile {
		return <AttFile>{
					id: 0,
					name: file.name,
					mimeType: file.type,
					size: file.size,
					content: fileContent.toBase64()
				};
	}
	
	function isValidFile(uploadingFile: File, typeFilterArray: string[]): boolean {
		if (typeFilterArray && typeFilterArray.length>0) {
			let result = typeFilterArray.find(mimeType => uploadingFile.type.includes(mimeType));
			if (result === undefined) {
				return false;
			}
		}
		return true; //typeFilter is empty or result!=undefined
	}
	
	function filterToArray(typeFilter: string): string[] {
		return typeFilter?typeFilter.split(','):[];
	}
	
	function fileExists(uploadingFile: File): boolean {
		return fileStore.value && fileStore.value.some((file) => file.name === uploadingFile.name);
	}
	
</script>

<style>
</style>